import React from 'react';

const ResetIcon = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
        <defs>
          <clipPath id="clip-path">
            <path
              id="Rectangle_862"
              fill="#fff"
              stroke="#707070"
              d="M0 0H24V24H0z"
              data-name="Rectangle 862"
              transform="translate(485 479)"
            />
          </clipPath>
        </defs>
        <g id="Mask_Group_55" clipPath="url(#clip-path)" data-name="Mask Group 55" transform="translate(-485 -479)">
          <path
            id="load"
            fill="#000002"
            d={`M21.857 22.056l-1.766-2.333a1.177 1.177
            0 0 0-1.92 0l-1.766 2.333a.706.706 0 0 0 1.125.852l.963-1.272a8.546 8.546 0 1 1-5.7-8.749.706.706
            0 0 0 .467-1.332A9.967 9.967 0 1 0 19.9 21.8l.837 1.105a.706.706 0 0 0 1.125-.852z`}
            transform="translate(486 470.004)"
          />
        </g>
      </svg>
    </>
  );
};

export default ResetIcon;
